// GlobalRadioButtons.tsx
import React from 'react';
import { RadioButton } from 'primereact/radiobutton';

export interface RadioOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface GlobalRadioButtonsProps {
  label?: string;
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  layout?: 'horizontal' | 'vertical';
  gap?: number;
}

export const GlobalRadioButtons: React.FC<GlobalRadioButtonsProps> = ({
  label,
  options,
  value,
  onChange,
  required = false,
  disabled = false,
  error = '',
  layout = 'horizontal',
  gap = 24,
}) => {
  return (
    <div style={{ width: '100%' }}>
      {label && (
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: 600,
          color: error ? '#ef4444' : '#1e3a8a',
          marginBottom: '12px'
        }}>
          {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
        </label>
      )}
      
      <div style={{
        display: 'flex',
        flexDirection: layout === 'horizontal' ? 'row' : 'column',
        gap: `${gap}px`,
        flexWrap: 'wrap'
      }}>
        {options.map((option) => (
          <div 
            key={option.value} 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px' 
            }}
          >
            <RadioButton
              inputId={`radio-${option.value}`}
              value={option.value}
              onChange={(e) => onChange(e.value)}
              checked={value === option.value}
              disabled={disabled || option.disabled}
              className="global-radio"
            />
            <label
              htmlFor={`radio-${option.value}`}
              style={{
                fontSize: '14px',
                fontWeight: 500,
                color: value === option.value ? '#1e3a8a' : '#64748b',
                cursor: (disabled || option.disabled) ? 'not-allowed' : 'pointer',
                userSelect: 'none',
                transition: 'color 0.2s ease'
              }}
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
      
      {error && (
        <span style={{
          display: 'block',
          marginTop: '6px',
          fontSize: '12px',
          color: '#ef4444',
          fontWeight: 500
        }}>
          {error}
        </span>
      )}

      <style>{`
        .global-radio .p-radiobutton-box {
          width: 20px;
          height: 20px;
          border: 2px solid #94a3b8;
          transition: all 0.2s ease;
        }

        .global-radio .p-radiobutton-box:hover {
          border-color: #3b82f6;
        }

        .global-radio .p-radiobutton-box.p-highlight {
          border-color: #3b82f6;
          background: #3b82f6;
        }

        .global-radio .p-radiobutton-box .p-radiobutton-icon {
          width: 10px;
          height: 10px;
          background-color: white;
        }

        .global-radio .p-radiobutton-box.p-disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      `}</style>
    </div>
  );
};